module.exports = __webpack_public_path__ + "assets/img/back.f8c110cc.png";